import useMemo from "rc-util/es/hooks/useMemo";
import isEqual from "rc-util/es/isEqual";
import { defaultConfig } from '../../theme/internal';
export default function useTheme(theme, parentTheme) {
  var themeConfig = theme || {};
  var parentThemeConfig = themeConfig.inherit === false || !parentTheme ? defaultConfig : parentTheme;
  return useMemo(function () {
    if (!theme) {
      return parentTheme;
    } // Override


    var mergedComponents = Object.assign({}, parentThemeConfig.components);
    Object.keys(theme.components || {}).forEach(function (componentName) {
      mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
    }); // Base token

    return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
      token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
      components: mergedComponents
    });
  }, [themeConfig, parentThemeConfig], function (prev, next) {
    return prev.some(function (prevTheme, index) {
      var nextTheme = next[index];
      return !isEqual(prevTheme, nextTheme, true);
    });
  });
}